jQuery('#gateOnLeftContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    appendDots: jQuery('#gateOnLeftContentDots'),
});

jQuery('.staggered-content-gate-on-left .image-container .hotspot').click(function () {
    if (jQuery('.staggered-content-gate-on-left .image-container').attr('data-status') == 'open') {
        jQuery('.staggered-content-gate-on-left .image-container .gate').animate({left: "0%"}, 3000);
        jQuery('.staggered-content-gate-on-left .image-container').attr('data-status', 'closed');
    } else {
        jQuery('.staggered-content-gate-on-left .image-container .gate').animate({left: "-100%"}, 3000);
        jQuery('.staggered-content-gate-on-left .image-container').attr('data-status', 'open');
    }
});